import configJson from 'config/config.json';
import { handleResponse } from './apiService';
import { assetAmountInEth } from './assetsService';
import { newContractReader, useContractReader } from './contractReader';

export const getLandingNfts = () =>
  fetch(`${configJson.apiPath}/champion/nft`, { method: 'GET' })
    .then((res) => handleResponse(res, false))
    .then((res) => res.map((item) => ({ ...item, nft: { ...item.nft, animation: item.nft.animationLowRes } })));

export const getTikcetsInfo = async (nftId) => {
  const promises = [
    newContractReader({
      contractName: 'HordTicketManager',
      functionName: 'getAmountOfTicketsReserved',
      params: [nftId],
    }),

    newContractReader({ contractName: 'HordTicketFactory', functionName: 'getTokenSupply', params: [nftId] }),
  ];
  const [ticketsReseved, ticketsResevedTotal] = await Promise.all(promises);
  return [ticketsReseved, ticketsResevedTotal];
};

export const getNftTotalStaked = async (nftId) =>
  fetch(configJson.thegraphUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      query: `{
              nfts(where: { id:${nftId} }) {
                _totalAmountStaked
              }
            }`,
    }),
  })
    .then((res) => handleResponse(res))
    .then((res) => {
      if (res.errors) throw new Error(res.errors[0].message);

      if (res.data.nfts.length === 0) return '0';

      return assetAmountInEth(res.data.nfts[0]._totalAmountStaked, 'HORD');
    });
